import React from "react";

const Accordion: React.FC<{ children: React.ReactNode; open: boolean }> = ({ children, open }) => {
	const contentRef = React.useRef<HTMLDivElement>(null);

	return (
		<div
			ref={contentRef}
			className={`accordion-content${open ? " open" : ""}`}
			style={{
				maxHeight: open ? (contentRef.current ? contentRef.current.scrollHeight : 999) : 0,
				overflow: "hidden",
				transition: "max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
			}}>
			{children}
		</div>
	);
};

export default Accordion;
